import React, { useState } from 'react'
import Search from './CloneMain/Search'
import URL from './CloneMain/api/URL'
import './Design.css'
import VideoSec from './CloneMain/VideoSec'
import ListVideo from './CloneMain/ListVideo'

const App = () => {

    const [videos, setVideos] = useState([]);
    const [selectedVideos, setSelectedVideos] = useState({ id: {}, snippet: {} });

    async function videoSubmit(searchTerm) {
        const { data: { items: videos } } = await URL.get("search", {
            params: {
                part: "snippet",
                maxResults: 5,
                key: "AIzaSyB2ho4f1-R5Or3YYPSEijmu4v-k3NltIss",
                q: searchTerm
            }
        })

        console.log(videos);
        setVideos(videos);
        setSelectedVideos(videos[0]);
    }

    return (
        <>
            <div className="searchSec">
                <Search onSubmit={videoSubmit} />
            </div>
            <div className="videoMain">
                <div className="videoSec">
                    <VideoSec video={selectedVideos} />
                </div>
                <div className="videoLists">
                    <ListVideo videos={videos} onVideoSelect={setSelectedVideos} />
                </div>
            </div>
        </>
    )
}

export default App
